import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from '@/shared/shared.types';
import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';

export type C05MulticolumnCTAsProps = RenderingProps<
  C05MulticolumnCTAsFields,
  C05MulticolumnCTAParams
>;

export type C05MulticolumnCTAsFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
};

export type C05MulticolumnCTAParams = {
  BackgroundColor?: string;
  ContentAlignment?: string;
  HeadlineTag?: string;
  NumberOfColumns?: string;
  RemoveColumnMobilePadding?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
